import React, { useState } from "react";
import usePrivateLink from "../../../config/usePrivateLink";
import { Link } from "react-router-dom";
import { formatToDate } from "../../../master/FormatToDateTime";
import { closeModal, LoadingDiv, SweetAlertShow } from "../../../master/Master";
import { studentTuitionFeeChange } from "../../../../api/Student";

export default function CourseNFees({ data, handleFunction }) {
  const hasAccess = usePrivateLink();
  const [modalData, setModalData] = useState({});
  const [loading, setLoading] = useState(false);

  const handleTuitionFeeChange = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await studentTuitionFeeChange(formData);
      if (response.data.status) {
        closeModal("CourseNFeeUpdate");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
      handleFunction();
    }
  };

  return (
    <div className="row g-6">
      {loading && <LoadingDiv />}
      {data?.course_and_fees?.map((item) => (
        <div className="col-md-12" key={item?.id}>
          <div className="card border border-2 border-primary rounded-3">
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <span className="fs-6 badge bg-label-primary rounded-pill">
                    {item?.course?.title || "N/A"}:(
                    {item?.id})
                  </span>
                  <span
                    className={`badge ${
                      (Number(item?.batch?.status) === 0 ||
                        Number(item?.batch?.status) === 1) &&
                      Number(item?.status) === 1
                        ? "bg-label-success"
                        : "bg-label-danger"
                    } rounded-pill ms-2`}
                  >
                    {Number(item?.status) === 1 &&
                    (Number(item?.batch?.status) === 0 ||
                      Number(item?.batch?.status) === 1)
                      ? "Active"
                      : Number(item?.status) === 1 &&
                        Number(item?.batch?.status) === 2
                      ? "Finished"
                      : Number(item.status) === 4
                      ? "Transferred"
                      : "Inactive"}
                  </span>
                </div>
                <div className="col text-end">
                  <h2 className="mb-0 text-primary">
                    ₹
                    {Number(item?.total_fee) +
                      Number(item?.reg_fee) +
                      Number(item?.bus_final_fees)}
                  </h2>
                </div>
              </div>

              <ul className="list-unstyled g-2 my-3">
                <li className="mb-2 d-flex align-items-center">
                  <i className="ri-circle-fill ri-10px text-body me-2" />
                  <span>
                    Session: <b>{item?.session_year?.session}</b>
                  </span>
                </li>
                <li className="mb-2 d-flex align-items-center">
                  <i className="ri-circle-fill ri-10px text-body me-2" />
                  <span>
                    Batch: <b>{item?.batch?.title}</b>
                  </span>
                </li>
                <li className="mb-2 d-flex align-items-center">
                  {Number(item?.paid_reg_fee) === Number(item?.reg_fee) ? (
                    <i className="ri-check-fill text-success me-2" />
                  ) : (
                    <i className="ri-circle-fill ri-10px text-body me-2" />
                  )}
                  <span>
                    Registration Fee: ₹{item?.reg_fee} /{" "}
                    <span className="text-success">₹{item?.paid_reg_fee}</span>
                  </span>
                </li>
                <li className="mb-2 d-flex align-items-center">
                  {Number(item.total_fee) === Number(item?.fees_paid) ? (
                    <i className="ri-check-fill text-success me-2" />
                  ) : (
                    <i className="ri-circle-fill ri-10px text-body me-2" />
                  )}
                  <span>
                    Batch Fee: ₹{item?.total_fee} /{" "}
                    <span className="text-success">₹{item?.fees_paid}</span>
                  </span>
                </li>
                {item?.bus && item?.route && (
                  <li className="mb-2 d-flex align-items-center">
                    {Number(item?.bus_final_fees) ===
                    Number(item?.bus_paid_fees) ? (
                      <i className="ri-check-fill text-success me-2" />
                    ) : (
                      <i className="ri-circle-fill ri-10px text-body me-2" />
                    )}
                    <span>
                      Bus Fee: ₹{item?.bus_final_fees} /{" "}
                      <span className="text-success">
                        ₹{item?.bus_paid_fees || 0}
                      </span>
                    </span>
                  </li>
                )}

                <li className="mb-2 d-flex align-items-center">
                  <i className="ri-circle-fill ri-10px text-body me-2" />
                  <span>
                    Paid Fees: ₹
                    {Number(item?.fees_paid) +
                      Number(item?.bus_paid_fees) +
                      Number(item?.paid_reg_fee)}
                  </span>
                </li>
                {item?.batch_discount > 0 && (
                  <li className="mb-2 d-flex align-items-center">
                    <i className="ri-circle-fill ri-10px text-body me-2" />
                    <span>Batch Discount: ₹{item?.batch_discount}</span>
                  </li>
                )}
                {(() => {
                  const val =
                    Number(item?.total_fee) +
                    Number(item?.bus_final_fees) +
                    Number(item?.reg_fee) -
                    (Number(item?.paid_reg_fee) +
                      Number(item?.bus_paid_fees) +
                      Number(item?.fees_paid));
                  if (val) {
                    return (
                      <li className="mb-2 d-flex align-items-center">
                        <i className="ri-alert-fill text-danger me-2" />
                        <span>
                          Remaining Fees:
                          <span className="badge bg-danger ms-2">₹{val}</span>
                        </span>
                      </li>
                    );
                  }
                })()}
              </ul>
              <hr />

              <div className="d-flex justify-content-between align-items-center mb-1">
                <span className="h6 mb-0">Fee Status</span>
                <span className="h6 mb-0">
                  {item?.fee_status === "0" ? "Pending" : "Paid"}
                </span>
              </div>

              <div className="progress mb-1 rounded" style={{ height: 6 }}>
                <div
                  className="progress-bar rounded"
                  role="progressbar"
                  style={{
                    width: `${(
                      ((Number(item?.fees_paid) +
                        Number(item?.paid_reg_fee) +
                        Number(item?.bus_paid_fees)) /
                        (Number(item?.total_fee) +
                          Number(item?.reg_fee) +
                          Number(item?.bus_final_fees))) *
                      100
                    ).toFixed(0)}%`,
                  }}
                  aria-valuenow={
                    ((Number(item?.fees_paid) +
                      Number(item?.paid_reg_fee) +
                      Number(item?.bus_paid_fees)) /
                      (Number(item?.total_fee) +
                        Number(item?.reg_fee) +
                        Number(item?.bus_final_fees))) *
                    100
                  }
                  aria-valuemin={0}
                  aria-valuemax={100}
                />
              </div>

              <small>
                Paid: ₹
                {Number(item?.fees_paid) +
                  Number(item?.paid_reg_fee) +
                  Number(item?.bus_paid_fees)}{" "}
                / ₹
                {Number(item?.total_fee) +
                  Number(item.reg_fee) +
                  Number(item?.bus_final_fees)}
              </small>

              <div className="d-flex gap-3 mt-6">
                {hasAccess("/student/fees/deposit") && (
                  <Link
                    to={`/student/fees/deposit?id=${item?.student_id}`}
                    className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                  >
                    Pay Fees
                  </Link>
                )}
                {(hasAccess("/student/batch/transfer") ||
                  hasAccess("/student/course/discount") ||
                  hasAccess("/student/course/discount/view") ||
                  hasAccess("/student/bus/discount") ||
                  hasAccess("/student/bus/discount/view")) && (
                  <button
                    className="btn btn-sm btn-outline-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#CourseNFeeView"
                    onClick={() => setModalData(item)}
                  >
                    View
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}

      <div
        className="modal fade"
        id="CourseNFeeView"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header py-3 bg-label-primary">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Batch Details
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-5">
                <div className="col-md-6">
                  <h6 className="text-primary">Basic Info</h6>
                  <p>
                    <strong>Roll No:</strong> {modalData.roll_number}
                  </p>
                  <p>
                    <strong>Admission Date:</strong>{" "}
                    {formatToDate(modalData.admission_date)}
                  </p>
                  <p>
                    <strong>Status:</strong>{" "}
                    {Number(modalData?.status) === 1 &&
                    (Number(modalData?.batch?.status) === 0 ||
                      Number(modalData?.batch?.status) === 1)
                      ? "Active"
                      : Number(modalData?.status) === 1 &&
                        Number(modalData?.batch?.status) === 2
                      ? "Finished"
                      : Number(modalData.status) === 4
                      ? "Transferred"
                      : "Inactive"}
                  </p>
                </div>

                {/* Course Info */}
                <div className="col-md-6">
                  <h6 className="text-primary">Course Info</h6>
                  <p>
                    <strong>Session:</strong> {modalData.session_year?.session}
                  </p>
                  <p>
                    <strong>Course:</strong> {modalData.course?.title}
                  </p>
                  <p>
                    <strong>Batch:</strong> {modalData.batch?.title}
                  </p>
                </div>

                {/* Fee Info */}
                <div className="col-md-6">
                  <h6 className="text-primary">Fee Details</h6>
                  <p>
                    <strong>Registration Fee:</strong> ₹{modalData?.reg_fee} /{" "}
                    <span className="text-success">
                      ₹{modalData?.paid_reg_fee}
                    </span>
                  </p>
                  <p>
                    <strong>Total Tuition Fee:</strong> ₹{modalData.batch_fees}
                  </p>
                  <p>
                    <strong>Tuition Fee Discount:</strong> ₹
                    {modalData.batch_discount}
                  </p>
                  <p>
                    <strong>Final Tuition Fee:</strong> ₹{modalData?.total_fee}{" "}
                    /{" "}
                    <span className="text-success">
                      ₹{modalData?.fees_paid}
                    </span>
                  </p>
                </div>

                <div className="col-md-6">
                  {modalData?.bus_fees > 0 && (
                    <>
                      <p>
                        <strong>Total Transport Fee:</strong> ₹
                        {modalData.bus_fees}
                      </p>
                      <p>
                        <strong>Transport Fee Discount:</strong> ₹
                        {modalData.bus_discount}
                      </p>
                      <p>
                        <strong>Final Transport Fee:</strong> ₹
                        {modalData?.bus_final_fees} /{" "}
                        <span className="text-success">
                          ₹{modalData?.bus_paid_fees}
                        </span>
                      </p>
                    </>
                  )}
                  <p className="fw-bold fs-5 text-primary">
                    <strong>Total Fee:</strong> ₹
                    {Number(modalData?.total_fee) +
                      Number(modalData.reg_fee) +
                      Number(modalData?.bus_final_fees)}{" "}
                    / ₹
                    {Number(modalData?.fees_paid) +
                      Number(modalData?.paid_reg_fee) +
                      Number(modalData?.bus_paid_fees)}
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer py-3 bg-label-primary">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-info"
                data-bs-toggle="modal"
                data-bs-target="#CourseNFeeUpdate"
                onClick={() => closeModal("CourseNFeeView")}
              >
                Update Fee Detail
              </button>
              {Number(modalData?.status) === 1 && (
                <Link
                  onClick={() => closeModal("CourseNFeeView")}
                  to={`/student/batch/transfer?batch=${modalData?.batch_id}&course_n_fee_id=${modalData?.id}`}
                  className="btn btn-primary"
                >
                  Transfer Batch
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="CourseNFeeUpdate"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleTuitionFeeChange} method="post">
              <div className="modal-header py-3 bg-label-primary">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Tuition Fee Change
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-5">
                  <div className="col-12">
                    <h5 className="text-primary m-0">Course Info</h5>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <strong>Session:</strong>{" "}
                      {modalData.session_year?.session}
                    </p>
                    <p>
                      <strong>Course:</strong> {modalData.course?.title}
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <strong>Batch:</strong> {modalData.batch?.title}
                    </p>
                    <p>
                      <strong>Total Tuition Fee:</strong> ₹
                      {modalData.batch_fees}
                    </p>
                  </div>

                  <div className="col-md-12">
                    <hr className="m-0" />
                  </div>
                  <div className="col-md-6">
                    <input
                      name="student_id"
                      id="student_id"
                      type="hidden"
                      className="form-control"
                      value={modalData?.student_id}
                    />
                    <input
                      name="course_n_fee_id"
                      id="course_n_fee_id"
                      type="hidden"
                      className="form-control"
                      value={modalData?.id}
                    />
                    <div className="form-floating form-floating-outline">
                      <select
                        name="rte_status"
                        id="rte_status"
                        className="form-select"
                        value={modalData?.rte}
                        onChange={(e) =>
                          setModalData({
                            ...modalData,
                            rte: e.target.value,
                          })
                        }
                      >
                        <option value="" selected disabled>
                          Select RTE Status
                        </option>

                        <option value="RTE">RTE</option>
                        <option value="NON-RTE">NON-RTE</option>
                      </select>
                      <label htmlFor=""> Select RTE Status</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        name="final_fee"
                        id="final_fee"
                        type="number"
                        className="form-control"
                        value={modalData?.total_fee}
                        placeholder="Final Tuition Fee"
                        onChange={(e) =>
                          setModalData({
                            ...modalData,
                            total_fee: e.target.value,
                          })
                        }
                        required
                      />
                      <label htmlFor="">Final Tuition Fee</label>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-floating form-floating-outline">
                      <textarea
                        name="discount_remark"
                        id="discount_remark"
                        className="form-control input-uppercase"
                        placeholder="Discount Remark"
                        required
                      />
                      <label htmlFor="">Discount Remark</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-info">
                  Update Details
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
